import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetOpenDockWarehouseDetailsFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  stopIndex: number
  config: Partial<HttpClientConfig>
}

export function getOpenDockWarehouseDetailsFactory({
  repository,
}: GetOpenDockWarehouseDetailsFactoryDependencies) {
  return async function getOpenDockWarehouseDetails({ shipmentUUID, stopIndex, config }: Params) {
    try {
      return await repository.getOpenDockWarehouseDetails(shipmentUUID, stopIndex, config)
    } catch (error) {
      throw new Error('Could not get OpenDock warehouse details', { cause: error as Error })
    }
  }
}

export function getOpenDockWarehouseDetails({ shipmentUUID, stopIndex, config }: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const newGetOpenDockWarehouseDetails = getOpenDockWarehouseDetailsFactory({
    repository,
  })
  return newGetOpenDockWarehouseDetails({ shipmentUUID, stopIndex, config })
}
